export default {
  getDataEstadosCidades: (state) => {
    return state.dataEstadosCidades;
  },
  getLoadingEstadosCidades: (state) => {
    return state.loadingGeral.initialize;
  }
};
